import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function RequireRole({ allow = ['admin'], fallback = '/auth', children }) {
    const { user, loading } = useAuth();
    if (loading) return <div className="page container">Проверяем доступ…</div>;
    if (!user || !allow.includes(user.role)) return <Navigate to={fallback} replace />;
    return children;
}
